import { useEffect } from 'react';
import { useController } from 'react-hook-form';
import useGeneratorStore from '@/state/generator-store';

export const useModelVersionControl = (defaultValue: string) => {
  const { register, control, generatorForm } = useGeneratorStore((state) => ({
    register: state.register,
    control: state.control,
    generatorForm: state.generatorForm,
  }));

  const {
    field: { value, onChange },
  } = useController({
    name: 'model',
    control,
  });

  const { setValue } = generatorForm ?? {};

  const toggleVersion = () => {
    const versions = ['2.0', '1.6sf'];
    const currentIndex = versions.indexOf(value);
    const nextIndex = (currentIndex + 1) % versions.length;
    const newValue = versions[nextIndex];

    onChange(newValue);
    setValue?.('model', newValue);
  };

  useEffect(() => {
    register('model');
    onChange(defaultValue);
    setValue?.('model', defaultValue);
  }, [register, defaultValue]);

  return {
    value,
    toggleVersion,
  };
};
